module.exports = __webpack_public_path__ + "static/media/v12.058cf739.mp4";